import React from 'react';
import { OrderSide } from 'communication/types/order/OrderSide';
import styleConstants from 'widgets/fillsGraph/variables.module.scss';
import { getColourForSide } from 'utils/css/cssUtils';

interface FillSizeProps {
    side?: OrderSide;
}

export default function FillSize({ side }: FillSizeProps) {
    const fill = getColourForSide(side);
    return (
        <svg
            width="12px"
            height="25px"
            viewBox="0 0 12 25"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g fill={fill}>
                <rect x="5" y="0" width="2" height="25" />
                <circle
                    strokeWidth="1"
                    stroke={styleConstants.nodeStrokeColour}
                    cx="6"
                    cy="12.5"
                    r="5"
                />
            </g>
        </svg>
    );
}
